<template>
  <div>
    <div v-loading="is_loading">
      <HeaderSteps :title="campaign.name" :dialog="false" :back-path="{ name: 'social-boost' }">
        <template slot="action-menu">
          <TblAction :campaign="campaign" :index="0" redirectTo="social-boost" :circle="true" :is-header="true" />
        </template>

        <template slot="tabs">
          <div class="flex items-center justify-center gap-1">
            <RouterLink :to="{ name: 'view-campaign-flights' }" class="menuItem"> Flights </RouterLink>
            <RouterLink :to="{ name: 'view-campaign-analytics' }" class="menuItem"> Analytics </RouterLink>
            <RouterLink :to="{ name: 'view-campaign-reports' }" class="menuItem"> Reports </RouterLink>
            <RouterLink :to="{ name: 'view-campaign-activity' }" class="menuItem"> Activity </RouterLink>
          </div>
        </template>
      </HeaderSteps>
      <div class="flex flex-wrap Page__scrollable-content">
        <!-- summary col -->
        <div class="w-1/5 h-full">
          <Summary />
        </div>
        <!-- end summary col -->
        <!-- content col -->
        <div class="w-4/5 py-3 h-full">
          <div class="h-full pr-3">
            <RouterView class="Campaigns--child Loading__target h-full" />
          </div>
        </div>
        <!-- end content col -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderSteps from '@/components/social-products/social-boost/parts/HeaderSteps.vue'
import Summary from '@/components/social-products/social-boost/parts/Summary.vue'
import TblAction from '@/components/social-products/social-boost/parts/table/TableAction.vue'
import ClearDataMixin from '@/mixins/social-products/ClearData.js'

export default {
  mixins: [ClearDataMixin],
  components: {
    HeaderSteps,
    Summary,
    TblAction,
  },
  data() {
    return {}
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['campaign']),
    ...mapGetters('app', ['is_loading']),
    is_simple() {
      return this.campaign?.is_simple ?? false
    },
  },
  methods: {
    async init() {
      await this.$store.dispatch('socialBoostCampaign/getCampaign', { id: this.$route.params.id })
      if (this.is_simple) {
        this.$router.push({ name: 'social-boost' })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.menuItem {
  @apply text-dark font-bold border-b-2 border-transparent px-2 py-1 hover:text-primary;
  &.router-link-active {
    @apply border-primary text-primary;
  }
}
</style>
